const TypographyMainExampleHtmlCss = `
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  href="https://fonts.googleapis.com/css2?family=Rubik:wght@300;400&display=swap"
  rel="stylesheet"
/>`;

export default TypographyMainExampleHtmlCss;
